import React from 'react';
import useStyles from './VideoPreview.styles';
import CloseIcon from '@material-ui/icons/Close';
import { Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';

interface Props {
  open: boolean;
  source: string | null;
  onClose: () => void;
}

export const VideoPreview: React.FC<Props> = ({ source, open, onClose }: Props) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogActions>
        <IconButton onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogActions>

      <DialogContent className={classes.Content}>
        {source ? <video controls src={source} className={classes.Video} /> : null}
      </DialogContent>
    </Dialog>
  );
};
